import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "Dashboard",
    iconUrl: "assets/images/custom/sidebar/dash.svg",
    activeIconUrl: "assets/images/custom/sidebar/dash-a.svg",
    link: "/dashboard",
    width: 18,
  },
  {
    id: 2,
    label: "Schedule",
    iconUrl: "assets/images/custom/sidebar/ref.svg",
    activeIconUrl: "assets/images/custom/sidebar/ref-a.svg",
    link: "/referrals",
    width: 18,
  },
  {
    id: 3,
    label: "Scribe",
    iconUrl: "assets/images/custom/sidebar/scribe.svg",
    activeIconUrl: "assets/images/custom/sidebar/scribe-a.svg",
    link: "/scribe",
    width: 18,
  },
  {
    id: 15,
    label: "Charts",
    iconUrl: "assets/images/custom/chartsv3.svg",
    activeIconUrl: "assets/images/custom/chart-active.svg",
    link: "/procedure-list",
    width: 18,
  },
  {
    id: 16,
    label: "Biller",
    iconUrl: "assets/images/custom/sidebar/biller.png",
    activeIconUrl: "assets/images/custom/sidebar/biller-a.png",
    link: "/biller",
    width: 18,
  },
  {
    id: 4,
    label: "Orders",
    iconUrl: "assets/images/custom/sidebar/orders.svg",
    activeIconUrl: "assets/images/custom/sidebar/orders-a.svg",
    link: "/orders",
    width: 18,
  },
  // {
  //   id: 5,
  //   label: "Patients",
  //   iconUrl: "assets/images/custom/sidebar/engage.svg",
  //   activeIconUrl: "assets/images/custom/sidebar/engage-a.svg",
  //   link: "/patients",
  //   width: 18,
  // },
  {
    id: 6,
    label: "Engage",
    iconUrl: "assets/images/custom/sidebar/engage.svg",
    activeIconUrl: "assets/images/custom/sidebar/engage-a.svg",
    link: "/engage",
    width: 18,
  },
  {
    id: 7,
    label: "Chats",
    iconUrl: "assets/images/custom/sidebar/aya-inactive.svg",
    activeIconUrl: "assets/images/custom/sidebar/aya-active.svg",
    link: "/chats",
    width: 18,
  },
  {
    id: 9,
    label: "Templates",
    iconUrl: "assets/images/custom/sidebar/apps.svg",
    activeIconUrl: "assets/images/custom/sidebar/apps-a.svg",
    link: "/templates",
    width: 18,
  },
];

/** Pinned above the account menu (Ask Aya Health layout). */
export const MY_APPS_MENU_ITEM: MenuItem = {
  id: 8,
  label: "My Apps",
  iconUrl: "assets/images/custom/sidebar/my-apps.svg",
  activeIconUrl: "assets/images/custom/sidebar/my-apps-a.svg",
  link: "/my-apps",
  width: 18,
};
